import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import StarIcon from '@mui/icons-material/StarBorder';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';



function Docs() {
    return(
        <React.Fragment>
        <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
        <CssBaseline />
        <AppBar
          position="static"
          color="default"
          elevation={0}
          sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
        >
          <Toolbar sx={{ flexWrap: 'wrap' }}>
            <Typography variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
              Company name
            </Typography>
            <nav>
              <Link
                variant="button"
                color="text.primary"
                href="/"
                sx={{ my: 1, mx: 1.5 }}
              >
                Home
              </Link>
              <Link
                variant="button"
                color="text.primary"
                href="/docs"
                sx={{ my: 1, mx: 1.5 }}
              >
                Docs
              </Link>
              <Link
                variant="button"
                color="text.primary"
                href="/dashboard"
                sx={{ my: 1, mx: 1.5 }}
              >
                Dashboard
              </Link>
            </nav>
            <Button href="#" variant="outlined" sx={{ my: 1, mx: 1.5 }}>
              Login
            </Button>
          </Toolbar>
        </AppBar>

        {/* main page */}
        <h1>Docs</h1>
        <div style={{ width: '80%', textAlign: "left", margin: "auto" }}>
            <h1>Bash</h1>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                // fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                bash howlong.sh "event1" start<br />
                bash howlong.sh "event1" checkpoint "checkpoint1"<br />
                bash howlong.sh "event1" checkpoint "checkpoint2"<br />
                bash howlong.sh "event1" end<br />
                </code>
            </Box>
            <h1>Python</h1>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                // fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                howlong = HowLong()<br />
                howlong.start("event1")<br />
                howlong.event("event1").checkpoint("checkpoint1")<br />
                howlong.event("event1").checkpoint("checkpoint2")<br />
                howlong.end("event1")<br />
                </code>
            </Box>
            


            <h1>JavaScript</h1>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                // fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                start("event1");<br />
                event("event1").checkpoint("checkpoint1");<br />
                event("event1").checkpoint("checkpoint2");<br />
                end("event2");<br />
                </code>
            </Box>

            <h1>Cross Platform Example</h1>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                // fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                # bash script<br />
                bash howlong.sh "my app deployment" start<br />
                ...<br />
                bash howlong.sh "my app deployment" checkpoint "docker build complete"<br />
                ...<br />
                </code>
            </Box>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                // fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                # backend.py<br />
                ...<br />
                howlong.event("my app deployment").checkpoint("backend loaded")<br />
                ...<br />
                </code>
            </Box>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                // fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                // frontend.js<br />
                ...<br />
                event("my app deployment").checkpoint("frontend loaded");<br />
                ...<br />
                end("event2");<br />
                </code>
            </Box>
            <img src={require('./docs-example.png')} width="981px" />
            <br />
            <br />
            <br />
            <br />
           
        </div>

        {/* end main page */}




      </React.Fragment>
    );
}


export default Docs;